import{Tooltip as t}from"@mantine/core";import{jsx as r}from"@emotion/react/jsx-runtime";function o(p){return r(t,{...p})}export{o as Tooltip};
